import { render, staticRenderFns } from "./MitAdminReservableSpacesPage.vue?vue&type=template&id=e80373ca&scoped=true"
import script from "./MitAdminReservableSpacesPage.vue?vue&type=script&lang=js"
export * from "./MitAdminReservableSpacesPage.vue?vue&type=script&lang=js"
import style0 from "./MitAdminReservableSpacesPage.vue?vue&type=style&index=0&id=e80373ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80373ca",
  null
  
)

export default component.exports